import script from "./QRCode.vue?vue&type=script&lang=js"
export * from "./QRCode.vue?vue&type=script&lang=js"

import "./QRCode.vue?vue&type=style&index=0&id=2f59483b&scoped=true&lang=css"

import exportComponent from "/var/www/html/HR/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f59483b"]])

export default __exports__